"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeEventFactory = void 0;
const analytics_core_1 = require("@segment/analytics-core");
const get_message_id_1 = require("../lib/get-message-id");
class NodeEventFactory extends analytics_core_1.CoreEventFactory {
    constructor() {
        super({
            createMessageId: get_message_id_1.createMessageId,
            onFinishedEvent: (event) => {
                (0, analytics_core_1.assertUserIdentity)(event);
            },
        });
    }
}
exports.NodeEventFactory = NodeEventFactory;
//# sourceMappingURL=event-factory.js.map